import { useTranslation } from 'react-i18next';

type ChannelValue = 'all' | 'spa' | 'whatsapp' | 'shopify' | 'vto_embed' | 'api';

interface ChannelFilterDropdownProps {
  value: ChannelValue;
  onChange: (value: ChannelValue) => void;
  /** Hide the built-in "Canal" label (when the caller already renders one). */
  hideLabel?: boolean;
}

const CHANNEL_OPTIONS: ChannelValue[] = ['all', 'spa', 'whatsapp', 'shopify', 'vto_embed', 'api'];

export function ChannelFilterDropdown({ value, onChange, hideLabel = false }: ChannelFilterDropdownProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2">
      {!hideLabel && <label className="text-xs text-snapfy-text-secondary">{t('common:channel')}</label>}
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as ChannelValue)}
        className="bg-snapfy-surface-hover border border-snapfy-border rounded-button px-3 py-1.5 text-xs text-white focus:ring-[#7063f7] focus:border-[#7063f7] outline-none"
      >
        {CHANNEL_OPTIONS.map((opt) => (
          <option key={opt} value={opt}>
            {t(`common:channels.${opt === 'vto_embed' ? 'vtoEmbed' : opt}`)}
          </option>
        ))}
      </select>
    </div>
  );
}

export type { ChannelValue };
